/*------------------------------------------------------------------------------------------------------------------
about：url处理
author：马兆铿
date：2018-1-15
* -----------------------------------------------------------------------------------------------------------------*/
export function getQueryString(key) {
  var reg = new RegExp("(^|&)"+key+"=([^&]*)(&|$)");
  var result = window.location.search.substr(1).match(reg);
  return result?decodeURIComponent(result[2]):null;
}


// WEBPACK FOOTER //
// ./src/utils/url.js